import React from 'react';
import OrderDetails from '../../components/order-details';
import { TabletProps } from '../../interface';

const OrdersDetailsPage: React.FC<TabletProps> = (Props) => {
  return <OrderDetails isTablet={Props.isTablet} />;
};

export default OrdersDetailsPage;
